module.exports = __webpack_public_path__ + "images/banner-bg__261100f437b29f24672d863fab425ad1.png";